/**
 * Validate email with RegEx
 * @param {string} email
 * @returns boolean
 */
export const validateEmail = (email: string) =>
  (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w\w+)+$/.test(email));

/**
 * Validate phone with RegEx
 * @param {string} phone
 * @returns boolean
 */
export const validatePhone = (phone: string) =>
  (/^(\+\d[ ]?)?\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(phone));

/**
 * Validate zip with RegEx
 * @param {string} zip
 * @returns boolean
 */
export const validateZip = (zip: string) =>
  (/^(\d{5})$/.test(zip));
